export default __webpack_public_path__ + "static/media/leadership_and_mental_health.26d65dfd.png";